import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private readonly publicAttendanceRoutes = ['/fichajes'];

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Promise<boolean | UrlTree> {
    if (this.isPublicRoute(state.url)) {
      return true;
    }

    return this.authService.ensureSession().then((valid) =>
      valid
        ? true
        : this.router.createUrlTree(['/login'], {
            queryParams: { returnUrl: state.url },
          }),
    );
  }

  private isPublicRoute(url: string): boolean {
    const path = url.split('?')[0];
    return this.publicAttendanceRoutes.some(
      (route) => path === route || path.startsWith(`${route}/`),
    );
  }
}
